import Modal from "react-modal";
import { Add } from "@material-ui/icons";
import React, { useState } from "react";
import "../Sidebar/SidebarStyle/SidebarOptions.css";
import { Button } from "@material-ui/core";
import emailjs from "emailjs-com";

function SidebarOptions({ categoryFilter }) {
  const [openModal, setOpenModal] = useState(false);

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_9wfritj",
        "template_zjmkqfj",
        e.target,
        "user_bZBSTVay3YWE4S0dWGYcY"
      )
      .then(
        (result) => {
          console.log(result.text);
        },
        (error) => {
          console.log(error.text);
        }
      );

    setOpenModal(false);
  };

  const categories = [
    {
      id: "C1",
      name: "All",
      imgUrl:
        "https://static8.depositphotos.com/1007156/919/v/950/depositphotos_9198224-stock-illustration-globe-of-the-world.jpg",
    },
    {
      id: "C2",
      name: "Software Project",
      imgUrl:
        "https://c.pxhere.com/photos/7b/1a/code_coding_computer_developer_developing_development_macbook_notebook-913320.jpg!d",
    },
    {
      id: "C3",
      name: "Engineering Project",
      imgUrl:
        "https://c.pxhere.com/photos/a7/72/gears_cogs_machine_machinery_mechanical_printing_press_gears_and_cogs_technology-818429.jpg!d",
    },
  ];

  return (
    <div className="sidebarOptions">
      {categories.map((category) => (
        <div
          className="sidebarOption"
          key={category.id}
          onClick={() => categoryFilter(category.name)}
        >
          {category.imgUrl && (
            <img
              src={category.imgUrl}
              srcSet={category.imgUrl}
              alt={category.name}
            />
          )}
          <p>{category.name}</p>
        </div>
      ))}

      <div className="sidebarOption">
        <Button onClick={() => setOpenModal(true)}>
          <Add />
          <p>Suggest Project Space</p>
        </Button>

        <Modal
          isOpen={openModal}
          onRequestClose={() => setOpenModal(false)}
          shouldCloseOnOverlayClick={false}
          style={{
            overlay: {
              width: 700,
              height: 600,
              backgroundColor: "transparent",
              boxShadow:
                "box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
              zIndex: "1000",
              top: "50%",
              left: "50%",
              marginTop: "-300px",
              marginLeft: "-350px",
            },
          }}
        >
          <form onSubmit={sendEmail} className="form-grp">
            <h3>Drop us a line</h3>
            <div className="form-element">
              <label>Your name</label>
              <input
                type="text"
                name="name"
                placeholder="Please enter your name"
                required
              />
            </div>
            <div className="form-element">
              <label>Email</label>
              <input
                type="text"
                name="email"
                placeholder="Please enter your email"
                required
              />
            </div>
            <div className="form-element">
              <label>Subject</label>
              <select name="subject">
                <option>Suggest Project Space 🚀</option>
                <option>Tell us about the bugs 🐛</option>
                <option>Tell us about a great builder 👷🏽</option>
              </select>
            </div>
            <div className="form-element">
              <label>Message</label>
              <textarea
                type="text"
                name="message"
                placeholder="Enter your message here"
                rows="6"
                required
              ></textarea>
            </div>
            <Button onClick={() => setOpenModal(false)}>Cancel</Button>
            <Button type="submit">Send</Button>
          </form>
        </Modal>
      </div>
    </div>
  );
}

export default SidebarOptions;
